
(function() {
  var module = {};
  var result = {};
  module.exports = { "zh-hk": { "i18n": { "duration": { "seconds": "{{ seconds }} 秒", "minutes": "{{ minutes }} 分鐘", "hours": "{{ hours }} 小時", "hoursAndMinutes": "{{ hours }} 小時 {{ minutes }} 分鐘", "days": "{{ days }} 日", "shortForm": { "seconds": "{{ seconds }} 秒", "minutes": "{{ minutes }} 分", "hours": "{{ hours }} 小時", "days": "{{ days }} 日", "hoursAndMinutes": "{{ hours }} 小時 {{ minutes }} 分" } }, "dateTime": { "shortForm": { "months": { "january": "一月", "february": "二月", "march": "三月", "april": "四月", "may": "五月", "june": "六月", "july": "七月", "august": "八月", "september": "九月", "october": "十月", "november": "十一月", "december": "十二月" } }, "monthAndDay": "{{monthName}} {{dayNumber}} 日 ", "monthAndYear": "{{yearNumber}} 年 {{monthName}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "zh-hk": "static-7.446"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.446",
    "da": "static-7.446",
    "de": "static-7.446",
    "el": "static-7.446",
    "en": "static-7.446",
    "es-mx": "static-7.446",
    "es": "static-7.446",
    "fi": "static-7.446",
    "fr": "static-7.446",
    "it": "static-7.446",
    "ja": "static-7.446",
    "ko": "static-7.446",
    "nl": "static-7.446",
    "no": "static-7.446",
    "pl": "static-7.446",
    "pt-br": "static-7.446",
    "sv": "static-7.446",
    "zh-cn": "static-7.446",
    "zh-hk": "static-7.446"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-hk', {version: 'static-7.446'}); }
})();


